(function () {
  var stage = document.getElementById("pdp-main");
  if (!stage) return;
  var opener = document.querySelector(".pdp-gallery [data-pdp-zoom-open]");
  [].slice.call(document.querySelectorAll("[data-pdp-thumb]")).forEach(function (btn) {
    btn.addEventListener("click", function () {
      var src = btn.getAttribute("data-pdp-thumb");
      if (src) stage.src = src;
      if (opener && btn.hasAttribute("data-pdp-index")) {
        opener.setAttribute("data-pdp-index", btn.getAttribute("data-pdp-index"));
      }
      [].slice.call(document.querySelectorAll("[data-pdp-thumb]")).forEach(function (b) {
        b.classList.toggle("is-on", b === btn);
      });
    });
  });
})();

/* mobile: gallery dots, qty stepper, sticky add-to-cart */
(function () {
  var track = document.querySelector("[data-pdp-track]");
  var dots = document.querySelector("[data-pdp-dots]");
  if (track && dots) {
    var ds = dots.children, raf;
    track.addEventListener("scroll", function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        for (var k = 0; k < ds.length; k++) ds[k].classList.toggle("is-on", k === i);
      });
    }, { passive: true });
  }

  var qty = document.querySelector("[data-pdp-qty]");
  if (qty) {
    var inp = qty.querySelector("input");
    qty.addEventListener("click", function (e) {
      var b = e.target.closest("[data-step]");
      if (!b) return;
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.step, 10));
    });
  }

  /* sticky bar: visible whenever the main Add button is off-screen (above OR below), hidden over the footer */
  var bar = document.querySelector("[data-pdp-sticky]");
  var form = document.getElementById("pdp-form");
  var foot = document.querySelector(".nn-footbar");
  if (bar && form) {
    var mq = matchMedia("(max-width: 900px)"), ticking = false, last = null;
    function sync() {
      ticking = false;
      var vh = innerHeight, f = form.getBoundingClientRect();
      var formVisible = f.bottom > 60 && f.top < vh - 20;
      var footIn = foot ? foot.getBoundingClientRect().top < vh : false;
      var on = mq.matches && !formVisible && !footIn;
      if (on === last) return;
      last = on;
      bar.classList.toggle("is-on", on);
      bar.setAttribute("aria-hidden", on ? "false" : "true");
      var btn = bar.querySelector("button");
      if (btn) btn.tabIndex = on ? 0 : -1;
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }
    addEventListener("scroll", req, { passive: true });
    addEventListener("resize", req, { passive: true });
    addEventListener("load", req);
    sync();
  }
})();

/* Fullscreen zoom: click/tap the product photo. Wheel, pinch, and double-tap zoom. */
(function () {
  var dataEl = document.getElementById("pdp-zoom-data");
  if (!dataEl) return;
  var images;
  try { images = JSON.parse(dataEl.textContent || "[]"); } catch (e) { return; }
  if (!images.length) return;

  var root = document.createElement("div");
  root.className = "pdp-zoom";
  root.hidden = true;
  root.setAttribute("role", "dialog");
  root.setAttribute("aria-modal", "true");
  root.setAttribute("aria-label", "Zoomed product image");
  root.innerHTML =
    '<button type="button" class="pdp-zoom-close" data-zoom-close aria-label="Close">×</button>' +
    '<button type="button" class="pdp-zoom-nav is-prev" data-zoom-prev aria-label="Previous image">‹</button>' +
    '<button type="button" class="pdp-zoom-nav is-next" data-zoom-next aria-label="Next image">›</button>' +
    '<div class="pdp-zoom-view" data-zoom-view><img alt="" draggable="false" data-zoom-img></div>' +
    '<p class="pdp-zoom-hint">Pinch, scroll, or double-tap to zoom</p>' +
    '<p class="pdp-zoom-count" data-zoom-count></p>';
  document.body.appendChild(root);

  var view = root.querySelector("[data-zoom-view]");
  var img = root.querySelector("[data-zoom-img]");
  var count = root.querySelector("[data-zoom-count]");
  var prevBtn = root.querySelector("[data-zoom-prev]");
  var nextBtn = root.querySelector("[data-zoom-next]");
  var index = 0, scale = 1, x = 0, y = 0, lockY = 0, opener = null;
  var pointers = new Map();
  var drag = null, pinch = null, lastTap = 0, lastTapX = 0, lastTapY = 0;

  function apply() {
    img.style.transform = "translate(" + x + "px," + y + "px) scale(" + scale + ")";
    root.classList.toggle("is-zoomed", scale > 1);
  }
  function clampPan() {
    var maxX = ((scale - 1) * img.clientWidth) / 2;
    var maxY = ((scale - 1) * img.clientHeight) / 2;
    x = Math.max(-maxX, Math.min(maxX, x));
    y = Math.max(-maxY, Math.min(maxY, y));
  }
  function show(i) {
    index = (i + images.length) % images.length;
    scale = 1; x = 0; y = 0; apply();
    var item = images[index];
    img.alt = item.alt || "";
    if (img.getAttribute("src") !== item.src) img.setAttribute("src", item.src);
    count.textContent = (index + 1) + " / " + images.length;
    root.classList.toggle("is-single", images.length < 2);
    root.setAttribute("aria-label", "Zoomed product image " + (index + 1) + " of " + images.length);
  }
  function openZoom(i, from) {
    opener = from || document.activeElement;
    show(i);
    root.hidden = false;
    lockY = window.scrollY || 0;
    document.body.style.position = "fixed";
    document.body.style.top = "-" + lockY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    root.querySelector("[data-zoom-close]").focus();
  }
  function closeZoom() {
    root.hidden = true;
    scale = 1; x = 0; y = 0; apply();
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    window.scrollTo(0, lockY);
    if (opener && opener.focus) opener.focus();
  }
  function zoomAt(clientX, clientY, next) {
    next = Math.max(1, Math.min(4, next));
    var rect = view.getBoundingClientRect();
    var cx = clientX - (rect.left + rect.width / 2);
    var cy = clientY - (rect.top + rect.height / 2);
    var k = scale ? next / scale : 1;
    x = cx - k * (cx - x);
    y = cy - k * (cy - y);
    scale = next;
    if (scale === 1) { x = 0; y = 0; }
    clampPan();
    apply();
  }

  document.querySelectorAll(".pdp-gallery [data-pdp-zoom-open]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      openZoom(parseInt(btn.getAttribute("data-pdp-index"), 10) || 0, btn);
    });
  });

  var track = document.querySelector("[data-pdp-track]");
  if (track) {
    var sx = 0, sy = 0, moved = false;
    track.addEventListener("pointerdown", function (e) {
      sx = e.clientX; sy = e.clientY; moved = false;
    }, { passive: true });
    track.addEventListener("pointermove", function (e) {
      if (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10) moved = true;
    }, { passive: true });
    track.addEventListener("click", function (e) {
      var hit = e.target.closest("[data-pdp-zoom-open]");
      if (!hit || moved) return;
      e.preventDefault();
      openZoom(parseInt(hit.getAttribute("data-pdp-index"), 10) || 0, hit);
    });
  }

  root.querySelector("[data-zoom-close]").addEventListener("click", closeZoom);
  prevBtn.addEventListener("click", function () { show(index - 1); });
  nextBtn.addEventListener("click", function () { show(index + 1); });

  view.addEventListener("wheel", function (e) {
    if (root.hidden) return;
    e.preventDefault();
    zoomAt(e.clientX, e.clientY, scale * (e.deltaY < 0 ? 1.18 : 0.85));
  }, { passive: false });

  view.addEventListener("pointerdown", function (e) {
    if (e.target.closest("button")) return;
    view.setPointerCapture(e.pointerId);
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pointers.size === 2) {
      var pts = Array.from(pointers.values());
      var dx = pts[0].x - pts[1].x, dy = pts[0].y - pts[1].y;
      pinch = { dist: Math.hypot(dx, dy) || 1, scale: scale };
      drag = null;
      return;
    }
    drag = { x: e.clientX, y: e.clientY, ox: x, oy: y, sx: e.clientX, sy: e.clientY, t: Date.now(), onImage: e.target === img };
  });
  view.addEventListener("pointermove", function (e) {
    if (!pointers.has(e.pointerId)) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pointers.size >= 2 && pinch) {
      var pts = Array.from(pointers.values());
      var dx = pts[0].x - pts[1].x, dy = pts[0].y - pts[1].y;
      var dist = Math.hypot(dx, dy) || 1;
      scale = Math.max(1, Math.min(4, pinch.scale * (dist / pinch.dist)));
      if (scale === 1) { x = 0; y = 0; }
      clampPan();
      apply();
      return;
    }
    if (drag && scale > 1) {
      x = drag.ox + (e.clientX - drag.x);
      y = drag.oy + (e.clientY - drag.y);
      clampPan();
      apply();
    }
  });
  view.addEventListener("pointerup", function (e) {
    var start = drag;
    pointers.delete(e.pointerId);
    if (pointers.size < 2) pinch = null;
    drag = null;
    if (!start) return;
    var dx = e.clientX - start.sx;
    var dy = e.clientY - start.sy;
    var dt = Date.now() - start.t;
    if (scale === 1 && Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) && dt < 600) {
      show(index + (dx < 0 ? 1 : -1));
      lastTap = 0;
      return;
    }
    if (Math.abs(dx) < 12 && Math.abs(dy) < 12 && !start.onImage) {
      closeZoom();
      return;
    }
    if (Math.abs(dx) < 12 && Math.abs(dy) < 12) {
      var now = Date.now();
      if (now - lastTap < 280 && Math.abs(e.clientX - lastTapX) < 30 && Math.abs(e.clientY - lastTapY) < 30) {
        if (scale > 1) zoomAt(e.clientX, e.clientY, 1);
        else zoomAt(e.clientX, e.clientY, 2);
        lastTap = 0;
      } else {
        lastTap = now;
        lastTapX = e.clientX;
        lastTapY = e.clientY;
      }
    }
  });
  view.addEventListener("pointercancel", function (e) {
    pointers.delete(e.pointerId);
    pinch = null;
    drag = null;
  });
  img.addEventListener("load", function () { clampPan(); apply(); });
  view.addEventListener("touchmove", function (e) {
    if (!root.hidden) e.preventDefault();
  }, { passive: false });

  document.addEventListener("keydown", function (e) {
    if (root.hidden) return;
    if (e.key === "Escape") { e.preventDefault(); closeZoom(); return; }
    if (e.key === "ArrowRight") {
      e.preventDefault();
      if (scale > 1) { x -= 40; clampPan(); apply(); }
      else show(index + 1);
    } else if (e.key === "ArrowLeft") {
      e.preventDefault();
      if (scale > 1) { x += 40; clampPan(); apply(); }
      else show(index - 1);
    } else if (e.key === "Tab") {
      var nodes = [root.querySelector("[data-zoom-close]"), prevBtn, nextBtn].filter(function (n) {
        return n && n.offsetParent !== null;
      });
      if (!nodes.length) return;
      var i = nodes.indexOf(document.activeElement);
      e.preventDefault();
      var next = nodes[(i + (e.shiftKey ? -1 : 1) + nodes.length) % nodes.length];
      next.focus();
    }
  });
})();
